import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute, type RouteComponentProps, type RouterState } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import { supportedSubfolderLocaleCodes } from 'bundles/internationalization-lib/constants/subfolderLocaleCodes';
import NotFound from 'bundles/phoenix/components/NotFound';
import { inferPageNumberFromParams } from 'bundles/search-common/utils/eventingUtils';
import { shouldUseSearchPageConfig } from 'bundles/search-common/utils/pageConfigUtils';
import SeoSearchApp from 'bundles/seo-entity-page/components/SeoSearchApp';

const SeoSearchPage = loadOnRoute(() => import('bundles/seo-entity-page/components/SeoSearchPage'));

const PageConfigSeoSearchPage = loadOnRoute(() => import('bundles/seo-entity-page/components/PageConfigSeoSearchPage'));

const ConditionalSeoSearchPage = (
  nextState: RouterState,
  callback: (err: Error | null, component?: React.ComponentType<RouteComponentProps<{}, {}>>) => void
) => {
  const { location } = nextState;
  const query = location?.query?.query;

  if (shouldUseSearchPageConfig(query)) {
    PageConfigSeoSearchPage(nextState, callback);
  } else {
    SeoSearchPage(nextState, callback);
  }
};

export default (
  <CourseraRoute
    path="/"
    component={SeoSearchApp}
    handle={{
      tracking: {
        data: (_, location) => {
          const currentPage = inferPageNumberFromParams(location?.query?.page);

          return {
            page: {
              segment: 'consumer',
              type: 'entity_query_page',
              pagination: {
                pageNumber: currentPage ? Number(currentPage) : 1,
              },
            },
          };
        },
      },
    }}
  >
    {/* Routes for subfolder localized EQP page */}
    {supportedSubfolderLocaleCodes.map((subfolderLocaleCode) => (
      <Route
        path={`${subfolderLocaleCode}/courses`}
        getComponent={ConditionalSeoSearchPage}
        key={subfolderLocaleCode}
      />
    ))}

    <Route path="courses" getComponent={ConditionalSeoSearchPage} />

    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </CourseraRoute>
);
